import { ApiResourceMethod } from '@/api/api-requests-factory';
import { TwoFactorPayload } from '@/models/auth/auth.model';

export default class TwoFactorCodeRequest extends ApiResourceMethod<TwoFactorPayload> {
  public perform({ code }: TwoFactorPayload): Promise<TwoFactorPayload> {
    return this.performer.requestWithMapper(
      { data: { code } },
    );
  }
}
